var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('banner',{attrs:{"type":"8"}}),_c('productList',{attrs:{"product-list":_vm.recommendList,"product-name":_vm.$route.query.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }